// extracted by mini-css-extract-plugin
export default {"status":"tracking_status__+48sA","active":"tracking_active__FRbEb"};